// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .app-main-content .details-view .main-content[data-v-1a658144]  {\n  height: 475px;\n  overflow-y: auto;\n}\n#app .app-main-content .details-view .main-content[data-v-1a658144]  .section .el-form-item__content {\n    width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
